export default "__VITE_ASSET__CTeHbHkC__"